import { useState, useEffect, useRef } from 'react';
import { Heading, Text } from '../../atoms';
import { useLanguage } from '../../../context/LanguageContext';
import './AboutSection.css';

function highlightName(text, name) {
  if (!text || !name) return text;
  const parts = text.split(name);
  if (parts.length < 2) return text;
  const result = [];
  parts.forEach((part, i) => {
    result.push(part);
    if (i < parts.length - 1) {
      result.push(
        <span key={`name-${i}`} className="about-section__name">
          {name}
        </span>
      );
    }
  });
  return result;
}

function AboutSection() {
  const { t } = useLanguage();
  const [isVisible, setIsVisible] = useState(() => {
    if (typeof window === 'undefined') return true;
    return window.innerWidth < 768;
  });
  const sectionRef = useRef(null);

  useEffect(() => {
    if (isVisible) return;
    const el = sectionRef.current;
    if (!el) return;
    if (typeof IntersectionObserver === 'undefined') {
      setIsVisible(true);
      return;
    }
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setIsVisible(true); },
      { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, [isVisible]);

  return (
    <section
      id="about"
      ref={sectionRef}
      className={`about-section ${isVisible ? 'about-section--visible' : ''}`}
    >
      <div className="about-section__inner">
        <div className="about-section__content">
          <span className="about-section__label">{t('about.label')}</span>
          <Heading level={2} className="about-section__title">{t('about.title')}</Heading>

          <div className="about-section__profiles">
            <div className="about-section__profile">
              <div className="about-section__profile-bio">
                <Text size="large" as="div">
                  {highlightName(t('about.patricia1'), t('about.patriciaName'))}
                </Text>
                <Text as="div">
                  {t('about.patricia1b')}
                </Text>
                <Text as="div">
                  {t('about.patricia2')}
                </Text>
              </div>
            </div>

            <div className="about-section__profile">
              <div className="about-section__profile-bio">
                <Text as="div">
                  {highlightName(t('about.luis'), t('about.luisName'))}
                </Text>
                <Text as="div">
                  {t('about.luis1b')}
                </Text>
              </div>
            </div>
          </div>
        </div>
        <div className="about-section__visual" aria-hidden>
          <img
            src="/img/patriciaPicTribunales.jpeg"
            alt=""
            className="about-section__visual-img"
          />
        </div>
      </div>
    </section>
  );
}

export default AboutSection;
